import apiClient from './client';

/**
 * Search for tags matching the query string (typeahead).
 * @param query - Search query string
 * @param limit - Maximum number of results (default: 10)
 * @returns Array of tag values matching the query
 */
export const searchTags = async (query: string, limit: number = 10): Promise<string[]> => {
  const response = await apiClient.get<string[]>('/tags/search', {
    params: { q: query, limit }
  });
  return response.data;
};

/**
 * Get all available tags.
 * @param limit - Maximum number of results (default: 50)
 * @returns Array of tag values
 */
export const getAllTags = async (limit: number = 50): Promise<string[]> => {
  const response = await apiClient.get<string[]>('/tags', {
    params: { limit }
  });
  return response.data;
};

export const tagsApi = {
  searchTags,
  getAllTags,
};

